<template>
  <main class="bg-white" v-if="ready && auctions">
    <h1 class="p-4 text-3xl font-bold text-center text-white bg-black">Enchère Machines Textiles</h1>
    <embed
      v-if="auctions.pdf_fr.data"
      :src="
        $i18n.locale == 'fr'
          ? auctions.pdf_fr.data.attributes.url +
            '#toolbar=0&zoom=' +
            windowWidth
          : auctions.pdf_en.data.attributes.url +
            '#toolbar=0&zoom=' +
            windowWidth
      "
      width="100%"
      height="1000"
      type="application/pdf"
    />
    <div class="flex flex-wrap justify-center m-auto md:w-3/5">
      <img
        v-for="(opportunity, index) in auctions.images.data"
        :key="index"
        class="h-auto p-2 w-60"
        :src="opportunity.attributes.url"
        :alt="'Enchère machine textile - Image ' + (index + 1)"
      />
    </div>
  </main>
</template>

<script>
import axios from "axios";
import useSeo from "../composables/useSeo";
export default {
  data() {
    return {
      auctions: "",
      windowWidth: 0,
      ready: false,
      baseUrl: process.env.VUE_APP_STRAPI_API_URL,
    };
  },
  mounted() {
    this.getMachine();
    this.windowWidth = window.innerWidth * (8 / 100);
    // window.addEventListener("resize", this.onResize);
  },
  methods: {
    async getMachine() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_STRAPI_API_URL}/api/auctions/${this.$route.params.id}?populate=*`
        );
        this.auctions = response.data.data.attributes;
        this.ready = true;
        const auctionUrl = `https://jacquart.com/auction/${this.$route.params.id}`;
        const auctionImage = this.auctions.images?.data?.[0]?.attributes.url || 'https://jacquart.com/og-image.jpg';
        useSeo({
          title: "Enchère Machines Textiles | Jacquart & Fils",
          meta: {
            description: "Découvrez cette enchère de machines textiles d'occasion chez Jacquart & Fils. Équipements de qualité au meilleur prix.",
            "og:type": "website",
            "og:title": "Enchère Machines Textiles | Jacquart & Fils",
            "og:description": "Découvrez cette enchère de machines textiles d'occasion chez Jacquart & Fils. Équipements de qualité au meilleur prix.",
            "og:url": auctionUrl,
            "og:image": auctionImage,
          },
          canonical: auctionUrl,
        });
      } catch (error) {
        this.error = error;
        console.log(error.response);
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth * (10 / 100);
      console.log(this.windowWidth);
    },
  },
};
</script>
